import { render, staticRenderFns } from "./IbBlurredBox.vue?vue&type=template&id=f6a32630&scoped=true"
import script from "./IbBlurredBox.vue?vue&type=script&lang=js"
export * from "./IbBlurredBox.vue?vue&type=script&lang=js"
import style0 from "./IbBlurredBox.vue?vue&type=style&index=0&id=f6a32630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a32630",
  null
  
)

export default component.exports